export const mapDataMock = {
    "id": 8,
    "planing_id": 8,
    "name": "Quy hoạch chung TP Việt Trì, T. Phú Thọ đến năm 2030",
    "planning-name": "Quy hoạch chung TP Việt Trì, T. Phú Thọ đến năm 2030",
    "is_lock": false,
    "z_index": 0,
    "zoom": 12,
    "min_zoom": 5,
    "max_zoom": 24,
    "projection": "EPSG:4326",
    "extent": "105.11443042095584,21.181716966197097,105.63495232166701,21.509130323548202",
    "center": "105.37469137131143,21.34542364487265",
    "is_active": true,
    "map_setting": [
        {
            "id": 221,
            "map_id": 8,
            "name": "MAP",
            "type_map": "MAP",
            "layer_categories": [],
            "base_maps": [
                {
                    "id": 17,
                    "name": "Nền giao thông",
                    "map_setting_id": 221,
                    "url": "https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
                    "z_index": 0,
                    "view_default": true,
                    "ordinal": 0,
                    "base_map_setting_id": 2,
                    "baseMapSettingModel": {
                        "id": 2,
                        "name": "Bản đồ nền giao thông",
                        "url": "https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
                        "layer_type": "GOOGLE",
                        "status": false
                    }
                },
                {
                    "id": 18,
                    "name": "Nền vệ tinh",
                    "map_setting_id": 221,
                    "url": "https://mt.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
                    "z_index": 0,
                    "view_default": false,
                    "ordinal": 0,
                    "base_map_setting_id": 3,
                    "baseMapSettingModel": {
                        "id": 3,
                        "name": "Bản đồ nền vệ tinh",
                        "url": "https://mt.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
                        "layer_type": "VETINH",
                        "status": false
                    }
                }
            ]
        },
        {
            "id": 222,
            "map_id": 8,
            "name": "Layer",
            "type_map": "LAYER",
            "layer_categories": [
                {
                    "id": 8,
                    "folder_name": "Bản đồ hành chính",
                    "map_setting_id": 222,
                    "folder_label": "Bản đồ hành chính",
                    "level": 0,
                    "layer_settings": [
                        {
                            "id": 162,
                            "layer_category_id": 8,
                            "name": "Bản đồ hành chính",
                            "geo_layer_name": "Bản đồ hành chính",
                            "wms": "https://geoserver.phutho.gov.vn/geoserver/phutho/wms/",
                            "wms_external": false,
                            "filter_name": {
                                "in": [],
                                "out": [
                                    {
                                        "col": "gid",
                                        "kieu": "integer",
                                        "alias": "ID"
                                    },
                                    {
                                        "col": "manhandang",
                                        "kieu": "character varying",
                                        "alias": "manhandang"
                                    },
                                    {
                                        "col": "phienban",
                                        "kieu": "integer",
                                        "alias": "phienban"
                                    },
                                    {
                                        "col": "ngayphienb",
                                        "kieu": "date",
                                        "alias": "ngayphienb"
                                    },
                                    {
                                        "col": "giatridoch",
                                        "kieu": "numeric",
                                        "alias": "giatridoch"
                                    },
                                    {
                                        "col": "nguyennhan",
                                        "kieu": "character varying",
                                        "alias": "nguyennhan"
                                    },
                                    {
                                        "col": "madoituong",
                                        "kieu": "character varying",
                                        "alias": "madoituong"
                                    },
                                    {
                                        "col": "madonvihan",
                                        "kieu": "character varying",
                                        "alias": "madonvihan"
                                    },
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất"
                                    },
                                    {
                                        "col": "dientich",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)"
                                    },
                                    {
                                        "col": "sodan",
                                        "kieu": "bigint",
                                        "alias": "sodan"
                                    },
                                    {
                                        "col": "shape_leng",
                                        "kieu": "numeric",
                                        "alias": "shape_leng"
                                    },
                                    {
                                        "col": "shape_area",
                                        "kieu": "numeric",
                                        "alias": "shape_area"
                                    },
                                    {
                                        "col": "ten_loai_dat",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_dat"
                                    },
                                    {
                                        "col": "chu_giai",
                                        "kieu": "character varying",
                                        "alias": "chu_giai"
                                    },
                                    {
                                        "col": "created_by",
                                        "kieu": "text",
                                        "alias": "created_by"
                                    },
                                    {
                                        "col": "created_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "created_date"
                                    },
                                    {
                                        "col": "modified_by",
                                        "kieu": "text",
                                        "alias": "modified_by"
                                    },
                                    {
                                        "col": "modified_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "modified_date"
                                    },
                                    {
                                        "col": "planning_id",
                                        "kieu": "bigint",
                                        "alias": "planning_id"
                                    },
                                    {
                                        "col": "gallery",
                                        "kieu": "jsonb",
                                        "alias": "gallery"
                                    },
                                    {
                                        "col": "documents",
                                        "kieu": "jsonb",
                                        "alias": "documents"
                                    }
                                ]
                            },
                            "display_name": {
                                "cols": [
                                    {
                                        "col": "gid",
                                        "kieu": "integer",
                                        "alias": "ID",
                                        "index": 0
                                    },
                                    {
                                        "col": "objectid",
                                        "kieu": "bigint",
                                        "alias": "objectid",
                                        "index": 1
                                    },
                                    {
                                        "col": "manhandang",
                                        "kieu": "character varying",
                                        "alias": "manhandang",
                                        "index": 2
                                    },
                                    {
                                        "col": "phienban",
                                        "kieu": "integer",
                                        "alias": "phienban",
                                        "index": 3
                                    },
                                    {
                                        "col": "ngayphienb",
                                        "kieu": "date",
                                        "alias": "ngayphienb",
                                        "index": 4
                                    },
                                    {
                                        "col": "giatridoch",
                                        "kieu": "numeric",
                                        "alias": "giatridoch",
                                        "index": 5
                                    },
                                    {
                                        "col": "nguyennhan",
                                        "kieu": "character varying",
                                        "alias": "nguyennhan",
                                        "index": 6
                                    },
                                    {
                                        "col": "madoituong",
                                        "kieu": "character varying",
                                        "alias": "madoituong",
                                        "index": 7
                                    },
                                    {
                                        "col": "madonvihan",
                                        "kieu": "character varying",
                                        "alias": "madonvihan",
                                        "index": 8
                                    },
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất",
                                        "index": 9
                                    },
                                    {
                                        "col": "dientich",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)",
                                        "index": 10
                                    },
                                    {
                                        "col": "sodan",
                                        "kieu": "bigint",
                                        "alias": "sodan",
                                        "index": 11
                                    },
                                    {
                                        "col": "shape_leng",
                                        "kieu": "numeric",
                                        "alias": "shape_leng",
                                        "index": 12
                                    },
                                    {
                                        "col": "shape_area",
                                        "kieu": "numeric",
                                        "alias": "shape_area",
                                        "index": 13
                                    },
                                    {
                                        "col": "geom",
                                        "kieu": "USER-DEFINED",
                                        "alias": "geom",
                                        "index": 14
                                    },
                                    {
                                        "col": "ten_loai_dat",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_dat",
                                        "index": 15
                                    },
                                    {
                                        "col": "chu_giai",
                                        "kieu": "character varying",
                                        "alias": "chu_giai",
                                        "index": 16
                                    },
                                    {
                                        "col": "created_by",
                                        "kieu": "text",
                                        "alias": "created_by",
                                        "index": 17
                                    },
                                    {
                                        "col": "created_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "created_date",
                                        "index": 18
                                    },
                                    {
                                        "col": "modified_by",
                                        "kieu": "text",
                                        "alias": "modified_by",
                                        "index": 19
                                    },
                                    {
                                        "col": "modified_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "modified_date",
                                        "index": 20
                                    },
                                    {
                                        "col": "planning_id",
                                        "kieu": "bigint",
                                        "alias": "planning_id",
                                        "index": 21
                                    },
                                    {
                                        "col": "gallery",
                                        "kieu": "jsonb",
                                        "alias": "gallery",
                                        "index": 22
                                    },
                                    {
                                        "col": "documents",
                                        "kieu": "jsonb",
                                        "alias": "documents",
                                        "index": 23
                                    }
                                ],
                                "popup": {
                                    "use": true,
                                    "cols": [
                                        "gid",
                                        "manhandang",
                                        "phienban",
                                        "ngayphienb",
                                        "giatridoch",
                                        "nguyennhan",
                                        "madoituong",
                                        "madonvihan",
                                        "ten",
                                        "dientich",
                                        "sodan",
                                        "shape_leng",
                                        "shape_area",
                                        "ten_loai_dat",
                                        "chu_giai",
                                        "created_by",
                                        "created_date",
                                        "modified_by",
                                        "modified_date",
                                        "planning_id",
                                        "gallery",
                                        "documents"
                                    ]
                                },
                                "tooltip": {
                                    "use": true,
                                    "cols": [
                                        "gid",
                                        "manhandang",
                                        "phienban",
                                        "ngayphienb",
                                        "giatridoch",
                                        "nguyennhan",
                                        "madoituong",
                                        "madonvihan",
                                        "ten",
                                        "dientich",
                                        "sodan",
                                        "shape_leng",
                                        "shape_area",
                                        "ten_loai_dat",
                                        "chu_giai",
                                        "created_by",
                                        "created_date",
                                        "modified_by",
                                        "modified_date",
                                        "planning_id",
                                        "gallery",
                                        "documents"
                                    ]
                                },
                                "viewdetail": {
                                    "use": false,
                                    "cols": []
                                }
                            },
                            "display": null,
                            "filter": null,
                            "table": "phutho_diagioihccaphuyen_polygon",
                            "level": 0,
                            "z_index": 1,
                            "min_zoom": 0,
                            "max_zoom": 20,
                            "is_check": false,
                            "layer_type": "wms",
                            "style": null,
                            "select_multi": false,
                            "document_upload_id": null,
                            "files": {
                                "fileName": null,
                                "fileType": null,
                                "filePreview": null,
                                "fileSize": 0,
                                "fileId": null
                            },
                            "layerRealationshipId": 0,
                            "year": 0,
                            "contentChange": null,
                            "planningId": 0,
                            "layerRealationships": [],
                            "geoTiff": "",
                            "sourceExternal": null
                        }
                    ]
                },
                {
                    "id": 369,
                    "folder_name": "Quy hoạch sử dụng đất",
                    "map_setting_id": 222,
                    "folder_label": "Quy hoạch sử dụng đất",
                    "level": 50,
                    "layer_settings": [
                        {
                            "id": 163,
                            "layer_category_id": 369,
                            "name": "Rải thửa",
                            "geo_layer_name": "Rải thửa",
                            "wms": "https://geoserver.phutho.gov.vn/geoserver/phutho/wms/",
                            "wms_external": false,
                            "filter_name": {
                                "in": [
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất",
                                        "type_display": ""
                                    },
                                    {
                                        "col": "dt",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)",
                                        "type_display": ""
                                    }
                                ],
                                "out": [
                                    {
                                        "col": "gid",
                                        "kieu": "integer",
                                        "alias": "ID"
                                    },
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất"
                                    },
                                    {
                                        "col": "dt",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)"
                                    },
                                    {
                                        "col": "ten_loai_d",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_d"
                                    },
                                    {
                                        "col": "chu_giai",
                                        "kieu": "character varying",
                                        "alias": "chu_giai"
                                    },
                                    {
                                        "col": "ten_loai_dat",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_dat"
                                    },
                                    {
                                        "col": "created_by",
                                        "kieu": "text",
                                        "alias": "created_by"
                                    },
                                    {
                                        "col": "created_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "created_date"
                                    },
                                    {
                                        "col": "modified_by",
                                        "kieu": "text",
                                        "alias": "modified_by"
                                    },
                                    {
                                        "col": "modified_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "modified_date"
                                    },
                                    {
                                        "col": "planning_id",
                                        "kieu": "bigint",
                                        "alias": "planning_id"
                                    },
                                    {
                                        "col": "gallery",
                                        "kieu": "jsonb",
                                        "alias": "gallery"
                                    },
                                    {
                                        "col": "documents",
                                        "kieu": "jsonb",
                                        "alias": "documents"
                                    }
                                ]
                            },
                            "display_name": {
                                "cols": [
                                    {
                                        "col": "gid",
                                        "kieu": "integer",
                                        "alias": "ID",
                                        "index": 0
                                    },
                                    {
                                        "col": "id",
                                        "kieu": "numeric",
                                        "alias": "id",
                                        "index": 1
                                    },
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất",
                                        "index": 2
                                    },
                                    {
                                        "col": "layer",
                                        "kieu": "character varying",
                                        "alias": "Phân loại",
                                        "index": 3
                                    },
                                    {
                                        "col": "dt",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)",
                                        "index": 4
                                    },
                                    {
                                        "col": "ten_loai_d",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_d",
                                        "index": 5
                                    },
                                    {
                                        "col": "chu_giai",
                                        "kieu": "character varying",
                                        "alias": "chu_giai",
                                        "index": 6
                                    },
                                    {
                                        "col": "geom",
                                        "kieu": "USER-DEFINED",
                                        "alias": "geom",
                                        "index": 7
                                    },
                                    {
                                        "col": "ten_loai_dat",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_dat",
                                        "index": 8
                                    },
                                    {
                                        "col": "created_by",
                                        "kieu": "text",
                                        "alias": "created_by",
                                        "index": 9
                                    },
                                    {
                                        "col": "created_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "created_date",
                                        "index": 10
                                    },
                                    {
                                        "col": "modified_by",
                                        "kieu": "text",
                                        "alias": "modified_by",
                                        "index": 11
                                    },
                                    {
                                        "col": "modified_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "modified_date",
                                        "index": 12
                                    },
                                    {
                                        "col": "planning_id",
                                        "kieu": "bigint",
                                        "alias": "planning_id",
                                        "index": 13
                                    },
                                    {
                                        "col": "gallery",
                                        "kieu": "jsonb",
                                        "alias": "gallery",
                                        "index": 14
                                    },
                                    {
                                        "col": "documents",
                                        "kieu": "jsonb",
                                        "alias": "documents",
                                        "index": 15
                                    }
                                ],
                                "popup": {
                                    "use": true,
                                    "cols": [
                                        "gid",
                                        "ten",
                                        "dt",
                                        "ten_loai_d",
                                        "chu_giai",
                                        "ten_loai_dat",
                                        "created_by",
                                        "created_date",
                                        "modified_by",
                                        "modified_date",
                                        "planning_id",
                                        "gallery",
                                        "documents"
                                    ]
                                },
                                "tooltip": {
                                    "use": true,
                                    "cols": [
                                        "gid",
                                        "ten",
                                        "dt",
                                        "ten_loai_d",
                                        "chu_giai",
                                        "ten_loai_dat",
                                        "created_by",
                                        "created_date",
                                        "modified_by",
                                        "modified_date",
                                        "planning_id",
                                        "gallery",
                                        "documents"
                                    ]
                                },
                                "viewdetail": {
                                    "use": true,
                                    "cols": [
                                        "gid",
                                        "ten",
                                        "dt"
                                    ]
                                }
                            },
                            "display": null,
                            "filter": null,
                            "table": "qhc_sdd_tpviettri_01",
                            "level": 0,
                            "z_index": 0,
                            "min_zoom": 0,
                            "max_zoom": 20,
                            "is_check": false,
                            "layer_type": "wms",
                            "style": null,
                            "select_multi": true,
                            "document_upload_id": null,
                            "files": {
                                "fileName": null,
                                "fileType": null,
                                "filePreview": null,
                                "fileSize": 0,
                                "fileId": null
                            },
                            "layerRealationshipId": 0,
                            "year": 0,
                            "contentChange": null,
                            "planningId": 8,
                            "layerRealationships": [],
                            "geoTiff": "",
                            "sourceExternal": null
                        },
                        {
                            "id": 1000,
                            "layer_category_id": 369,
                            "name": "Rải thửa",
                            "geo_layer_name": "Rải thửa",
                            "wms": "https://geo3.cgis.asia/geoserver/diachiso/wms/",
                            "wms_external": false,
                            "filter_name": {
                                "in": [
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất",
                                        "type_display": ""
                                    },
                                    {
                                        "col": "dt",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)",
                                        "type_display": ""
                                    }
                                ],
                                "out": [
                                    {
                                        "col": "gid",
                                        "kieu": "integer",
                                        "alias": "ID"
                                    },
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên loại đất"
                                    },
                                    {
                                        "col": "dt",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)"
                                    },
                                    {
                                        "col": "ten_loai_d",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_d"
                                    },
                                    {
                                        "col": "chu_giai",
                                        "kieu": "character varying",
                                        "alias": "chu_giai"
                                    },
                                    {
                                        "col": "ten_loai_dat",
                                        "kieu": "character varying",
                                        "alias": "ten_loai_dat"
                                    },
                                    {
                                        "col": "created_by",
                                        "kieu": "text",
                                        "alias": "created_by"
                                    },
                                    {
                                        "col": "created_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "created_date"
                                    },
                                    {
                                        "col": "modified_by",
                                        "kieu": "text",
                                        "alias": "modified_by"
                                    },
                                    {
                                        "col": "modified_date",
                                        "kieu": "timestamp without time zone",
                                        "alias": "modified_date"
                                    },
                                    {
                                        "col": "planning_id",
                                        "kieu": "bigint",
                                        "alias": "planning_id"
                                    },
                                    {
                                        "col": "gallery",
                                        "kieu": "jsonb",
                                        "alias": "gallery"
                                    },
                                    {
                                        "col": "documents",
                                        "kieu": "jsonb",
                                        "alias": "documents"
                                    }
                                ]
                            },
                            "display_name": {
                                "cols": [
                                    {
                                        "col": "chusohuu",
                                        "kieu": "character varying",
                                        "alias": "Chủ sở hữu",
                                        "index": 0
                                    },
                                    {
                                        "col": "ten",
                                        "kieu": "character varying",
                                        "alias": "Tên",
                                        "index": 1
                                    },
                                    {
                                        "col": "diachi",
                                        "kieu": "character varying",
                                        "alias": "Địa chỉ",
                                        "index": 2
                                    },
                                    {
                                        "col": "sonha",
                                        "kieu": "character varying",
                                        "alias": "Số nhà",
                                        "index": 3
                                    },
                                    {
                                        "col": "duong",
                                        "kieu": "character varying",
                                        "alias": "Đường",
                                        "index": 4
                                    },
                                    {
                                        "col": "sothua",
                                        "kieu": "character varying",
                                        "alias": "Số thửa",
                                        "index": 5
                                    },
                                    {
                                        "col": "sotobando",
                                        "kieu": "character varying",
                                        "alias": "Số tờ bản đồ",
                                        "index": 6
                                    },
                                    {
                                        "col": "madiachi",
                                        "kieu": "character varying",
                                        "alias": "Mã địa chỉ",
                                        "index": 7
                                    },
                                    {
                                        "col": "mdsd",
                                        "kieu": "character varying",
                                        "alias": "Mục đích sử dụng",
                                        "index": 8
                                    },
                                    {
                                        "col": "dientich",
                                        "kieu": "numeric",
                                        "alias": "Diện tích (m2)",
                                        "index": 9
                                    },
                                    {
                                        "col": "lat",
                                        "kieu": "numeric",
                                        "alias": "Vĩ độ",
                                        "index": 10
                                    },
                                    {
                                        "col": "long",
                                        "kieu": "numeric",
                                        "alias": "Kinh độ",
                                        "index": 11
                                    },
                                    {
                                        "col": "link_vr",
                                        "kieu": "character varying",
                                        "alias": "Liên kết VR",
                                        "index": 12
                                    },
                                    {
                                        "col": "trinhbay",
                                        "kieu": "character varying",
                                        "alias": "Trình bày",
                                        "index": 13
                                    }
                                ],
                                "popup": {
                                    "use": true,
                                    "cols": [
                                        "chusohuu",
                                        "ten",
                                        "diachi",
                                        "sonha",
                                        "duong",
                                        "sothua",
                                        "sotobando",
                                        "madiachi",
                                        "mdsd",
                                        "dientich",
                                        "lat",
                                        "long",
                                        "link_vr",
                                        "trinhbay"
                                    ]
                                },
                                "tooltip": {
                                    "use": true,
                                    "cols": [
                                        "chusohuu",
                                        "ten",
                                        "diachi",
                                        "sonha",
                                        "duong",
                                        "sothua",
                                        "sotobando",
                                        "madiachi",
                                        "mdsd",
                                        "dientich",
                                        "lat",
                                        "long"
                                    ]
                                },
                                "viewdetail": {
                                    "use": true,
                                    "cols": [
                                        "chusohuu",
                                        "ten",
                                        "diachi",
                                        "dientich"
                                    ]
                                }
                            },
                            "display": null,
                            "filter": null,
                            "table": "raithua_tong",
                            "level": 0,
                            "z_index": 1,
                            "min_zoom": 0,
                            "max_zoom": 20,
                            "is_check": true,
                            "layer_type": "wms",
                            "style": null,
                            "select_multi": false,
                            "document_upload_id": null,
                            "files": {
                                "fileName": null,
                                "fileType": null,
                                "filePreview": null,
                                "fileSize": 0,
                                "fileId": null
                            },
                            "layerRealationshipId": 0,
                            "year": 0,
                            "contentChange": null,
                            "planningId": 8,
                            "layerRealationships": [],
                            "geoTiff": "",
                            "sourceExternal": null
                        }
                    ]
                },
            ],
            "base_maps": []
        }
    ],
    "map_planning-relationship": [],
    "created_by": "3b78f5a8-56d2-4fcf-8ba7-88fe3bb1b4d2",
    "created_date": "2021-12-22T17:31:39.223282+07:00",
    "modified_by": "3b78f5a8-56d2-4fcf-8ba7-88fe3bb1b4d2",
    "modified_date": "2023-11-04T08:48:24.176962+07:00"
}